module.exports = {
        srcSet: __webpack_public_path__ + "amenities_mcdonalds-200-9f430d90661a4c8f.digested.png"+" 200w",
        images: [{path: __webpack_public_path__ + "amenities_mcdonalds-200-9f430d90661a4c8f.digested.png",width: 200,height: 200}],
        src: __webpack_public_path__ + "amenities_mcdonalds-200-9f430d90661a4c8f.digested.png",
        toString: function(){return __webpack_public_path__ + "amenities_mcdonalds-200-9f430d90661a4c8f.digested.png"},
        
        width: 200,
        height: 200
      }